import React, { useState } from "react";
import useTranslation from "utils/hooks/useTranslation";
import LogoLogan from "./../assets/logo_logan.svg";
import SSOLogin from "./login/SSOLogin";
import UnregisteredInfo from "./login/UnRegistered";
import { Container, Content, FooterBar, LogoContainer, Logo, Label } from "./styles/index.styled";

const MultipleRealms = () => {
  const PRIVACY_INFORMATION = useTranslation({ id: "privacy_information" });

  const [isUnregisteredOpen, setIsUnregisteredOpen] = useState(false);

  const toggleUnregisteredOpen = () => setIsUnregisteredOpen((prev) => !prev);

  return (
    <Container>
      <Content>
        <LogoContainer>
          <Logo src={LogoLogan} alt="Logan logo" />
        </LogoContainer>
        {isUnregisteredOpen ? <UnregisteredInfo toggleUnregisteredOpen={toggleUnregisteredOpen} /> : <SSOLogin toggleUnregisteredOpen={toggleUnregisteredOpen} />}
      </Content>
      <FooterBar>
        <Label>{PRIVACY_INFORMATION}</Label>
      </FooterBar>
    </Container>
  );
};

export default MultipleRealms;
